import ConnectOrySelfHostedPanel from "./onboarding/ConnectOrySelfHostedPanel.jsx";

/**
 * Modal wrapper for editing self-hosted Ory project inputs.
 *
 * @param {{
 *   open: boolean,
 *   onClose: () => void,
 *   project: { projectId?: string } | null,
 *   onSaved?: (result: { attestation_stale?: boolean, input_change_summary?: string[] }) => void,
 * }} props
 */
export default function ConnectOrySelfHostedModal({ open, onClose, project, onSaved }) {
  const projectId = project?.projectId;
  if (!open || !projectId) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 200,
        background: "rgba(5, 8, 16, 0.72)",
        display: "grid",
        placeItems: "center",
        padding: "24px",
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="connect-ory-self-hosted-edit-title"
    >
      <div
        style={{
          width: "100%",
          maxWidth: "720px",
          maxHeight: "92vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          background: "var(--bg-surface)",
          border: "1px solid var(--border)",
          borderRadius: "10px",
        }}
      >
        <div style={{ padding: "20px 24px 0" }}>
          <h2 id="connect-ory-self-hosted-edit-title" style={{ fontSize: "18px", fontWeight: 600, marginBottom: 4 }}>
            Update configuration / inputs
          </h2>
          <p className="text-secondary" style={{ fontSize: 12, marginBottom: 12 }}>
            Changes apply to this project only — assessment history is preserved. Re-run assessment after saving.
          </p>
        </div>
        <ConnectOrySelfHostedPanel
          mode="edit"
          projectId={projectId}
          compact
          onBack={onClose}
          onSaved={(result) => {
            onSaved?.(result);
            onClose?.();
          }}
        />
      </div>
    </div>
  );
}
